import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Button, Typography, Paper } from '@mui/material';
import './hub.scss';

function Hub() {
    const navigate = useNavigate();

    const handleNavigateFTTH = () => {
        navigate('/list-ordenes?page=1');
    };

    const handleNavigateHuawei = () => {
        navigate('/huawei/ordenes');
    };

    return (
        <Container maxWidth="lg">
            <Box 
                sx={{ 
                    minHeight: '100vh', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: 4
                }}
            >
                <Typography variant="h3" component="h1" sx={{ mb: 4, fontWeight: 'bold', color: '#333' }}>
                    Seleccione el Sistema
                </Typography>
                
                <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <Paper 
                        elevation={3} 
                        sx={{ 
                            padding: 4, 
                            textAlign: 'center', 
                            minWidth: 300,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: 6
                            }
                        }}
                        onClick={handleNavigateFTTH}
                    >
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
                            FTTH - Nucleo
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
                            Sistema actual de gestión de órdenes y servicios
                        </Typography>
                        <Button 
                            variant="contained" 
                            size="large" 
                            fullWidth
                            sx={{ 
                                backgroundColor: '#1976d2',
                                '&:hover': { backgroundColor: '#115293' }
                            }}
                        >
                            Acceder
                        </Button>
                    </Paper>

                    <Paper 
                        elevation={3} 
                        sx={{ 
                            padding: 4, 
                            textAlign: 'center', 
                            minWidth: 300,
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: 6
                            }
                        }}
                        onClick={handleNavigateHuawei}
                    >
                        <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
                            HUAWEI
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
                            Sistema de gestión Huawei
                        </Typography>
                        <Button 
                            variant="contained" 
                            size="large" 
                            fullWidth
                            sx={{ 
                                backgroundColor: '#d32f2f',
                                '&:hover': { backgroundColor: '#9a0007' }
                            }}
                        >
                            Acceder
                        </Button>
                    </Paper>
                </Box>
            </Box>
        </Container>
    );
}

export default Hub;
